import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { VisitCoverage } from "../../types/Indicators.types"

interface CoverageGaugeProps {
  data: VisitCoverage
  title?: string
}

export default function CoverageGauge({ data, title }: CoverageGaugeProps) {
  const { t } = useTranslation("global")
  const percent = data.coveragePercent
  const circumference = 2 * Math.PI * 45
  const offset = circumference - (percent / 100) * circumference
  const color = percent >= 75 ? "#198754" : percent >= 50 ? "#ffc107" : "#dc3545"

  return (
    <Card className="shadow-sm border-0 h-100">
      <Card.Header className="bg-white border-bottom">
        <h6 className="mb-0">
          <i className="fas fa-bullseye me-2 text-primary" />
          {title || t("Visit Coverage")}
        </h6>
      </Card.Header>
      <Card.Body className="text-center">
        <svg width="140" height="140" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="45" fill="none" stroke="#e9ecef" strokeWidth="8" />
          <circle
            cx="50" cy="50" r="45" fill="none"
            stroke={color} strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
          />
          <text x="50" y="46" textAnchor="middle" className="fw-bold" fontSize="18" fill="#212529">
            {percent}%
          </text>
          <text x="50" y="62" textAnchor="middle" fontSize="8" fill="#6c757d">
            {t("coverage")}
          </text>
        </svg>
        <div className="mt-2">
          <span className="text-muted small">
            {data.visitedPlaces} / {data.totalPlaces} {t("places visited")}
          </span>
        </div>
      </Card.Body>
    </Card>
  )
}
